var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarehouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.83329 11.4583H3.24996V5.79167H11.75V11.4583H13.1666V3.91458L7.49996 1.64792L1.83329 3.91458V11.4583ZM0.416626 12.875V2.95833L7.49996 0.125L14.5833 2.95833V12.875H10.3333V7.20833H4.66663V12.875H0.416626ZM5.37496 12.875V11.4583H6.79163V12.875H5.37496ZM6.79163 10.75V9.33333H8.20829V10.75H6.79163ZM8.20829 12.875V11.4583H9.62496V12.875H8.20829Z",
    fill: "#555555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouse);
export default __webpack_public_path__ + "static/media/warehouse.8313fa36a0f5d345a24f1c5aee009aba.svg";
export { ForwardRef as ReactComponent };